module.exports = __webpack_public_path__ + "img/error-thumb.334518fa.png";